/**
 * Serbian (Latin) localization for PrimeReact components.
 * Replaces English defaults like "No available options", "No records found",
 * date formats, day/month names, etc.
 *
 * Registered globally in `index.tsx` via `addLocale('sr', ...)` and
 * activated in `App.tsx` via `<PrimeReactProvider value={{ locale: 'sr' }}>`.
 */
const sr = {
  startsWith: 'Počinje sa',
  contains: 'Sadrži',
  notContains: 'Ne sadrži',
  endsWith: 'Završava se sa',
  equals: 'Jednako',
  notEquals: 'Različito',
  noFilter: 'Bez filtera',
  lt: 'Manje od',
  lte: 'Manje ili jednako',
  gt: 'Veće od',
  gte: 'Veće ili jednako',
  dateIs: 'Datum je',
  dateIsNot: 'Datum nije',
  dateBefore: 'Datum pre',
  dateAfter: 'Datum posle',
  custom: 'Prilagođeno',
  clear: 'Obriši',
  apply: 'Primeni',
  matchAll: 'Svi uslovi',
  matchAny: 'Bilo koji uslov',
  addRule: 'Dodaj pravilo',
  removeRule: 'Ukloni pravilo',
  accept: 'Da',
  reject: 'Ne',
  choose: 'Izaberi',
  upload: 'Otpremi',
  cancel: 'Otkaži',
  pending: 'Na čekanju',
  fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
  completed: 'Završeno',
  dayNames: ['Nedelja', 'Ponedeljak', 'Utorak', 'Sreda', 'Četvrtak', 'Petak', 'Subota'],
  dayNamesShort: ['Ned', 'Pon', 'Uto', 'Sre', 'Čet', 'Pet', 'Sub'],
  dayNamesMin: ['Ne', 'Po', 'Ut', 'Sr', 'Če', 'Pe', 'Su'],
  monthNames: [
    'Januar',
    'Februar',
    'Mart',
    'April',
    'Maj',
    'Jun',
    'Jul',
    'Avgust',
    'Septembar',
    'Oktobar',
    'Novembar',
    'Decembar'
  ],
  monthNamesShort: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'Maj',
    'Jun',
    'Jul',
    'Avg',
    'Sep',
    'Okt',
    'Nov',
    'Dec'
  ],
  chooseYear: 'Izaberi godinu',
  chooseMonth: 'Izaberi mesec',
  chooseDate: 'Izaberi datum',
  prevDecade: 'Prethodna decenija',
  nextDecade: 'Sledeća decenija',
  prevYear: 'Prethodna godina',
  nextYear: 'Sledeća godina',
  prevMonth: 'Prethodni mesec',
  nextMonth: 'Sledeći mesec',
  prevHour: 'Prethodni sat',
  nextHour: 'Sledeći sat',
  prevMinute: 'Prethodni minut',
  nextMinute: 'Sledeći minut',
  prevSecond: 'Prethodna sekunda',
  nextSecond: 'Sledeća sekunda',
  am: 'pre podne',
  pm: 'po podne',
  today: 'Danas',
  weekHeader: 'Sed',
  firstDayOfWeek: 1,
  showMonthAfterYear: false,
  dateFormat: 'dd.mm.yy',
  weak: 'Slabo',
  medium: 'Srednje',
  strong: 'Jako',
  passwordPrompt: 'Unesite šifru',
  emptyFilterMessage: 'Nema rezultata',
  searchMessage: '{0} rezultata je dostupno',
  selectionMessage: '{0} stavki je izabrano',
  emptySelectionMessage: 'Nema izabrane stavke',
  emptySearchMessage: 'Nema rezultata',
  emptyMessage: 'Nema dostupnih opcija',
  aria: {
    trueLabel: 'Tačno',
    falseLabel: 'Netačno',
    nullLabel: 'Nije izabrano',
    star: '1 zvezdica',
    stars: '{star} zvezdica',
    selectAll: 'Izaberi sve',
    unselectAll: 'Poništi izbor',
    close: 'Zatvori',
    previous: 'Prethodni',
    next: 'Sledeći',
    navigation: 'Navigacija',
    scrollTop: 'Vrati na vrh',
    moveTop: 'Pomeri na vrh',
    moveUp: 'Pomeri gore',
    moveDown: 'Pomeri dole',
    moveBottom: 'Pomeri na dno',
    moveToTarget: 'Premesti na ciljnu listu',
    moveToSource: 'Premesti na izvornu listu',
    moveAllToTarget: 'Premesti sve na ciljnu listu',
    moveAllToSource: 'Premesti sve na izvornu listu',
    pageLabel: 'Strana {page}',
    firstPageLabel: 'Prva strana',
    lastPageLabel: 'Poslednja strana',
    nextPageLabel: 'Sledeća strana',
    prevPageLabel: 'Prethodna strana',
    rowsPerPageLabel: 'Redova po strani',
    jumpToPageDropdownLabel: 'Idi na stranu',
    jumpToPageInputLabel: 'Idi na stranu',
    selectRow: 'Izaberi red',
    unselectRow: 'Poništi izbor reda',
    expandRow: 'Proširi red',
    collapseRow: 'Skupi red',
    showFilterMenu: 'Prikaži meni filtera',
    hideFilterMenu: 'Sakrij meni filtera',
    filterOperator: 'Operator filtera',
    filterConstraint: 'Ograničenje filtera',
    editRow: 'Izmeni red',
    saveEdit: 'Sačuvaj izmenu',
    cancelEdit: 'Otkaži izmenu',
    listView: 'Pregled liste',
    gridView: 'Pregled mreže',
    slide: 'Slajd',
    slideNumber: '{slideNumber}',
    zoomImage: 'Uvećaj sliku',
    zoomIn: 'Uvećaj',
    zoomOut: 'Umanji',
    rotateRight: 'Rotiraj desno',
    rotateLeft: 'Rotiraj levo'
  }
};

export default sr;
